import { createRoot } from 'react-dom/client';

import { StoreProvider } from '@/stores/StoreProvider';

import App from './App';

createRoot(document.getElementById('root')!).render(
  <StoreProvider>
    <App />
  </StoreProvider>,
);
